module.exports = __webpack_public_path__ + "img/统一认证(3)@2x.54f8eba0.png";